import { IonRouterOutlet } from '@ionic/react';
import { useState } from 'react';
import { Redirect, Route } from 'react-router';

import NotificationModal from '@/components/common/NotificationModal';
import { ROUTES_PATH } from '@/constants';
import ChangePassword from '@/pages/Login/ChangePassword/ChangePassword';

/**
 * Usuario logado con una clave que no cumple los requisitos de seguridad:
 * sin menú ni resto de rutas, cualquier URL lleva al cambio de clave obligatorio.
 */
export default function ForcedPasswordChangeRoutes() {
  const [noticeAccepted, setNoticeAccepted] = useState<boolean>(false);

  return (
    <>
      <IonRouterOutlet id="main-router-outlet">
        <Route exact path={ROUTES_PATH.LOGIN_CHANGE_PASSWORD}>
          <ChangePassword forced />
        </Route>
        <Route>
          <Redirect to={ROUTES_PATH.LOGIN_CHANGE_PASSWORD} />
        </Route>
      </IonRouterOutlet>
      <NotificationModal
        showModal={!noticeAccepted}
        closeModal={() => setNoticeAccepted(true)}
        canDismiss={false}
        title="Actualiza tu contraseña."
        message="Para proteger tu cuenta, es necesario actualizar tu contraseña ya que la actual no cumple con los requisitos de seguridad"
      />
    </>
  );
}
